import type { XApiEventsModuleClientDeps, XApiEventsModuleClientType } from '../contracts/client';

export async function load(
  implementation: 'cet' | 'mocked',
  deps: XApiEventsModuleClientDeps
): Promise<XApiEventsModuleClientType> {
  switch (implementation) {
    case 'cet':
      return (await import('../implementations/cet/src/client')).create(deps);
    case 'mocked':
      return {};
    default:
      throw new Error(`Unknown xapi-events client implementation: ${implementation || '<missing>'}`);
  }
}
